import { render, staticRenderFns } from "./PCBAs.vue?vue&type=template&id=eb455046&"
import script from "./PCBAs.vue?vue&type=script&lang=js&"
export * from "./PCBAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports